"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessCase = exports.DEClosingStateMapping = exports.DEClosingStateEnum = exports.DE_ClosingStateArray = void 0;
exports.DE_ClosingStateArray = [
    'PENDING',
    'WORKING',
    'COMPLETED',
    'CANCELLED',
    'EXPIRED',
    'DELETED',
    'ERROR',
];
// Enum from the array
var DEClosingStateEnum;
(function (DEClosingStateEnum) {
    DEClosingStateEnum["PENDING"] = "PENDING";
    DEClosingStateEnum["WORKING"] = "WORKING";
    DEClosingStateEnum["COMPLETED"] = "COMPLETED";
    DEClosingStateEnum["CANCELLED"] = "CANCELLED";
    DEClosingStateEnum["EXPIRED"] = "EXPIRED";
    DEClosingStateEnum["DELETED"] = "DELETED";
    DEClosingStateEnum["ERROR"] = "ERROR";
})(DEClosingStateEnum || (exports.DEClosingStateEnum = DEClosingStateEnum = {}));
exports.DEClosingStateMapping = exports.DE_ClosingStateArray.reduce((acc, state) => {
    acc[state] = state;
    return acc;
}, {});
var BusinessCase;
(function (BusinessCase) {
    BusinessCase["Anfangsbestand"] = "Anfangsbestand";
    BusinessCase["Umsatz"] = "Umsatz";
    BusinessCase["Pfand"] = "Pfand";
    BusinessCase["PfandRueckzahlung"] = "PfandRueckzahlung";
    BusinessCase["MehrzweckgutscheinKauf"] = "MehrzweckgutscheinKauf";
    BusinessCase["MehrzweckgutscheinEinloesung"] = "MehrzweckgutscheinEinloesung";
    BusinessCase["EinzweckgutscheinKauf"] = "EinzweckgutscheinKauf";
    BusinessCase["EinzweckgutscheinEinloesung"] = "EinzweckgutscheinEinloesung";
    BusinessCase["Forderungsentstehung"] = "Forderungsentstehung";
    BusinessCase["Forderungsaufloesung"] = "Forderungsaufloesung";
    BusinessCase["Anzahlungseinstellung"] = "Anzahlungseinstellung";
    BusinessCase["Anzahlungsaufloesung"] = "Anzahlungsaufloesung";
    BusinessCase["Privateinlage"] = "Privateinlage";
    BusinessCase["Privatentnahme"] = "Privatentnahme";
    BusinessCase["Geldtransit"] = "Geldtransit";
    BusinessCase["DifferenzSollIst"] = "DifferenzSollIst";
    BusinessCase["TrinkgeldAG"] = "TrinkgeldAG";
    BusinessCase["TrinkgeldAN"] = "TrinkgeldAN";
    BusinessCase["Auszahlung"] = "Auszahlung";
    BusinessCase["Einzahlung"] = "Einzahlung";
    BusinessCase["Rabatt"] = "Rabatt";
    BusinessCase["Aufschlag"] = "Aufschlag";
    BusinessCase["Lohnzahlung"] = "Lohnzahlung";
    BusinessCase["ZuschussEcht"] = "ZuschussEcht";
    BusinessCase["ZuschussUnecht"] = "ZuschussUnecht";
})(BusinessCase || (exports.BusinessCase = BusinessCase = {}));
//# sourceMappingURL=de-closing.types.js.map